import { render, staticRenderFns } from "./ImageWaterFull.vue?vue&type=template&id=5388f541&scoped=true"
import script from "./ImageWaterFull.vue?vue&type=script&lang=js"
export * from "./ImageWaterFull.vue?vue&type=script&lang=js"
import style0 from "./ImageWaterFull.vue?vue&type=style&index=0&id=5388f541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5388f541",
  null
  
)

export default component.exports